import { CompanyMoneyFormatWithSymbol, Money } from '@libs/money/money.interfaces';

export interface Assets {
    addButton: string;
    favIcon: string;
    starIcon: string;
    halfStarIcon: string;
    checkMark: string;
}

interface Links {
    newsletter?: string;
    sembonus?: string;
}

interface ContentItem {
    text: string;
    href?: string;
}

type StructuredContent = ContentItem[][];

export interface LogoOptions {
    title: string;
    desc: string;
}

export enum CompanyNames {
    SEMBO = 'Sembo',
    DTF = 'DTF Travel',
    STENA_LINE = 'StenaLine',
}

interface InsuranceProductInfo {
    compensation?: Money;
    generalTerms?: string;
    purchaseTerms?: string;
}

interface InsuranceInfo {
    baggage?: InsuranceProductInfo;
    travel?: InsuranceProductInfo;
}

export interface Market {
    number: number;
    domain: string;
    domainRedirected?: string;
    isSubdomain: boolean;
    locale: string;
    fullLocale: string;
    name: string;
    homePage: string;
    supportPhone?: string;
    priorityPhone?: string;
    copyright: string;
    moneyFormat: CompanyMoneyFormatWithSymbol;
    assets: Assets;
    links?: Links;
    insurance?: InsuranceInfo;
    footerInfo: StructuredContent;
}

export enum Markets {
    ARGENTINA = 30,
    AUSTRALIA = 14,
    AUSTRIA = 12,
    BAHRAIN = 54,
    BELARUS = 55,
    BELGIUM = 41,
    BOLIVIA = 56,
    BRAZIL = 42,
    BULGARIA = 24,
    CANADA = 17,
    CHILE = 32,
    CHINA = 57,
    COLOMBIA = 31,
    CROATIA = 37,
    CUBA = 58,
    CYPRUS = 59,
    CZECHREPUBLIC = 25,
    DENMARK = 5,
    DOMINICANREPUBLIC = 60,
    DTFDENMARK = 405,
    ECUADOR = 34,
    EGYPT = 61,
    ESTONIA = 62,
    FINLAND = 6,
    FRANCE = 63,
    GERMANY = 7,
    GREECE = 53,
    HONGKONG = 51,
    HUNGARY = 13,
    ICELAND = 64,
    INDIA = 26,
    INDONESIA = 38,
    IRAN = 65,
    IRELAND = 11,
    ISRAEL = 36,
    ITALY = 66,
    JAPAN = 67,
    JORDAN = 68,
    KAZAKHSTAN = 69,
    KUWAIT = 70,
    LUXEMBOURG = 71,
    MALAYSIA = 40,
    MALTA = 72,
    MEXICO = 29,
    NETHERLANDS = 9,
    NEWZEELAND = 15,
    NIGERIA = 28,
    NORWAY = 4,
    OMAN = 73,
    PARAGUAY = 74,
    PERU = 33,
    PHILIPPINES = 27,
    POLAND = 8,
    PORTUGAL = 21,
    QATAR = 75,
    ROMANIA = 43,
    RUSSIA = 45,
    SAUDIARABIA = 76,
    SERBIA = 44,
    SINGAPORE = 19,
    SLOVAKIA = 47,
    SOUTHAFRICA = 18,
    SOUTHKOREA = 39,
    SPAIN = 20,
    SWEDEN = 1,
    STENASWEDEN = 101,
    STENANORWAY = 104,
    STENADENMARK = 105,
    STENAFINLAND = 106,
    STENAGERMANY = 107,
    STENAPOLAND = 108,
    STENANETHERLAND = 109,
    STENAUNITEDKINGDOM = 110,
    STENAIRELAND = 111,
    SWITZERLAND = 52,
    TAIWAN = 50,
    THAILAND = 48,
    TURKEY = 77,
    UKRAINE = 78,
    UNITEDARABEMIRATES = 23,
    UNITEDKINGDOM = 10,
    URUGUAY = 35,
    USA = 16,
    VENEZUELA = 79,
    VIETNAM = 49,
}

export enum MarketValidation {
    IsValid,
    NotValid,
    NeedsRedirection,
}
